import { fetchData, postData } from "./SimulatorApiService";
import { TranslationService } from "./TranslationService";

const endpoints = {
    getEmetteurs: "emetteurs",
    getIsins: "isins",
    getOATSimulationDetails: "isins/details",
    getPeriodicites: "frequencies",
    getMaturity: "maturity",
    getResultOATs: "run/oat",
    getResultBonds: "run/bonds",
    getAmortizationTable: "amortization/oat",
}

export const getEmetteurs = async () => {
    return await fetchData(endpoints.getEmetteurs);
}

export const getISINs = async (emetteur, instrument) => {
    return await fetchData(`${endpoints.getIsins}/${emetteur}/${instrument}`);
}

export const getSimulationDetails = async (isin) => {
    return await fetchData(`${endpoints.getOATSimulationDetails}/${isin}`);
}

export const getModeAmortissements = async (lang) => {
    return [
        {code:"IF", label:TranslationService.translate("amortization_if", lang)},
        {code: "ACD", label:TranslationService.translate("amortization_acd", lang)}
    ]
}

export const getPeriodicites = async (lang) => {
    return [
        {code: "A", label: TranslationService.translate("periodicity_year", lang)}, 
        {code: "S", label: TranslationService.translate("periodicity_semester", lang)}, 
        {code: "T", label: TranslationService.translate("periodicity_trimester", lang)}
    ]
}

export const getMaturites = async () => {
    let maturites = [];
    for(let i = 1; i <= 50; i++){
        maturites.push(i);
    }
    return maturites;
}

export const getMaturiteJours = async () => {
    return ["28", "91", "182", "364"]
}

export const getResultOATs = async (data) => {
    return await postData(endpoints.getResultOATs, data);
}

export const getResultBonds = async (data) => {
    return await postData(endpoints.getResultBonds, data);
}

export const getAmortizationTable = async (data) => {
    let results = await postData(endpoints.getAmortizationTable, data);
    results.forEach(l => l.fraction = Number(l.fraction.toFixed(2)))
    
    return results;
}